module.exports = __webpack_public_path__ + "static/media/card-3.6d2c3cb9.svg";